module.exports = __webpack_public_path__ + "media/images/zalo_blue_logo_with_white_label-0aeac314c8a80134261bc508d0b140d0.svg";